module.exports = __webpack_public_path__ + "static/media/vtex8.e437591d.png";